import React, { useEffect, useState } from 'react';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { PAGE_SIZE } from '../../../../_common/constant';
import Pagination from '../../../../components/pagination';
import Search from '../../../../components/search';
import { AgGridReact } from 'ag-grid-react';
import { showDate, showLocalDate } from '../../../../_common/functions';
import { useCycleCountApi } from '../../../../store/api/hooks/cycleCountApiHook';
import CreateStockpicking from '../../StockPicking/_components/createStockpicking';
import Drawer from '../../../../components/Drawer';
import Button from '../../../../components/elements/button';

interface genProps {
  partDetails: any;
}
const StockPickingHistory: React.FC<genProps> = ({ partDetails }) => {

  const spearPartsAPI = useSpearPartsApi();
  const cycleCountAPI = useCycleCountApi();
  const [gridApi, setGridApi] = useState<any>(null);
  const [gridColumnApi, setGridColumnApi] = useState<any>(null);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchParam, setSearchParam] = useState<string>('');
  const stockRef: any = React.createRef<HTMLButtonElement>();
  const addNewAdjustmentRef: any = React.createRef<HTMLButtonElement>();

  const [rowData, setRowData] = useState<any>(null)

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };
  const onRowClicked = (event: any) => {
    if (!event.event.target.closest('input[type="checkbox"]')) {
      event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
    }
  };
  const getSpearPartsList = () => {
    let payload: any = {
      pageSize: PAGE_SIZE,
      pageNumber: currentPage,
      searchParam: searchParam,
    };
    if (partDetails?.partsID) {
      payload.partsID = partDetails.partsID;
    }
    cycleCountAPI.GetStockPickingByPart(payload, (resp: any) => {
      console.log('Cycle Count List', resp);
      setRowData(resp.stockPickList ? resp.stockPickList : []);
      setTotalRecords(resp.totalRecord);
    }, (error: any) => {
      setRowData([]);
      setTotalRecords(0);
    });

  };

  useEffect(() => {
    if (rowData) {
      getSpearPartsList();
    }
  }, [currentPage, searchParam]);

  useEffect(() => {

    getSpearPartsList();

  }, []);

  const columnDefs = [
    { headerName: 'Pick No', field: 'pickNo', headerClass: 'bg-[#f0f0f0]' },
    { headerName: 'Pick Date', field: 'pickingDate', headerClass: 'bg-[#f0f0f0]', cellRenderer: (data: any) => <p>{showLocalDate(data.value)}</p> },
    { headerName: 'Picked By', field: 'pickedByName', headerClass: 'bg-[#f0f0f0]' },
    { headerName: 'Task Number', field: 'workOrderCode', headerClass: 'bg-[#f0f0f0]' },
    { headerName: 'Number of Parts', field: 'pickQuantity', headerClass: 'bg-[#f0f0f0]' },
    { headerName: 'Facility', field: 'facilityName', flex: 1, headerClass: 'bg-[#f0f0f0]' },
    // { headerName: 'Sub Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]' },

  ];

  return (

    <div>
      <h1 className='pl-5 mt-5'>Stock Picking History</h1>
      <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
        <Pagination
          perPage={PAGE_SIZE}
          totalRecords={totalRecords}
          onPageChange={setCurrentPage}
          currentPage={currentPage}
        />
        <div className='flex items-center gap-3'>
          <Search onSearch={setSearchParam} />

          <Drawer _ref={stockRef} onClose={() => {
            addNewAdjustmentRef?.current?.reset()
          }} outsideClose={false}>
            <Drawer.Button>
              {/* <Button>Add New Stock Picking</Button> */}
            </Drawer.Button>
            <Drawer.Content title='Create New Stock Picking' className='!w-[45rem]'>
              <CreateStockpicking _ref={addNewAdjustmentRef} partDetails={partDetails} onCreate={() => {
                stockRef.current.close();
                getSpearPartsList();
              }} onCancel={() => {
                stockRef.current.close();
              }} />
            </Drawer.Content>
          </Drawer>
        </div>

      </div>
      <div>
        <div className='bg-[#FAFAFA]'>

          <div className="ag-theme-alpine h-1/2">
            <AgGridReact
              columnDefs={columnDefs} // Pass columnDefs
              rowData={rowData || []} // Pass rowData
              pagination={false}
              rowSelection="multiple"
              onGridReady={onGridReady}
              domLayout="autoHeight"
              onRowClicked={onRowClicked}
              noRowsOverlayComponent={() => (
                <div className="flex items-center justify-center h-full">
                  <div className="text-center text-gray-500">
                    <div className="text-lg font-medium">No Data Found</div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockPickingHistory;